import {
  GTMContactDetails,
  ContactDetailsData,
} from "@/types/gtm/ContactDetailsEvent";
import { QuoteData } from "@/types/quote/quote-data";

function contactDetailsDataMap(attributes: QuoteData["attributes"]) {
  const { organiser } = attributes;

  if (organiser) {
    return {
      code_ref: "enhanced_conversion",
      user_details: {
        email_address: organiser?.email ?? "",
        phone_number: organiser?.telephone ?? null,
      } as ContactDetailsData,
    } as GTMContactDetails;
  }
  return {} as GTMContactDetails;
}

function contactDetailsFailedDataMap() {
  return {
    event: "site_errors",
    event_name: "user_provided",
    code_ref: "enhanced_conversion",
  } as unknown as GTMContactDetails;
}

export { contactDetailsDataMap, contactDetailsFailedDataMap };
